import { de } from "./de"
import { en } from "./en"
import { es } from "./es"
import { zh } from "./zh"

export const translations = {
  en,
  de,
  es,
  zh,
}

export type { TranslationKeys } from "./en"
